import { LitEntity, html, css } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import '../../common/bn-svg-icon';
import './export-bin-modal';

class ExportBinButton extends LitEntity {
  static get properties() {
    return {
      showModal: { type: Boolean },
      start: { type: String },
      end: { type: String },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      bn-svg-icon {
        margin-right: .25em;
      }
    `];
  }

  render() {
    return html`
      <button class="button button--contained" @click="${this._onClick}">
        <bn-svg-icon name="FileDocumentArrowRight"></bn-svg-icon> Export
      </button>

      <export-bin-modal
        .href="${this.href}"
        .start="${this.start}"
        .end="${this.end}"
        ?hide="${!this.showModal}"
        @close="${() => this.showModal = false}"
      ></export-bin-modal>
    `;
  }

  _onClick(e) {
    e.stopPropagation();
    this.showModal = true;
  }
}

window.customElements.define('export-bin-button', ExportBinButton);
